// export { default as useActiveWeb3React } from './Web3/useActiveWeb3React'
// export { useApproveCallback, useApproveCallbackFromTrade, ApprovalState } from './useApproveCallback'
// export { default as useBentoBox } from './useBentoBox'
// export { default as useBentoBoxAllowance } from './useBentoBoxAllowance'
// export { useColor, useListColor } from './useColor'
// export * from './useContract'
// export { default as useFuse } from './useFuse'
// export { default as useSortableData } from './useSortableData'
// export { default as useUSDCPrice, USDC } from './useUSDCPrice'
export * from './useSortedTokensByQuery'
export * from './utils'
import useSWR from 'swr'

const fetcher = (...args: [any]) => fetch(...args).then((res) => res.json())

/**
 * @return {Promise<void>} Prices API
 */
export function useTestApi() {
  const { data, error } = useSWR('/api/test', fetcher)
  return {
    farms: data,
    isLoading: !error && !data,
    isError: error,
  }
}
